import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Buffer } from "buffer";

@Injectable({
  providedIn: 'root',
})
export class AuthService {

   user:any;

  async login(loginData:any) {

    
    const data_string = `${loginData.username}:${loginData.password}`;

    const auth_bs_64 = `Basic ${Buffer
    .from(data_string, "utf-8")
    .toString("base64")}`;

    // Persist so BizzBeanAndreService can include API_AUTH on all subsequent requests
    sessionStorage.setItem('bbApiAuth', auth_bs_64);

    let headers = new HttpHeaders({
      "apiKey": "G37BF2948D54BB2A5CEF4D1BD3F3CA3123",
      "Content-Type":"application/json",
      "API_AUTH": auth_bs_64
    });
    return await this.http
      .post(`https://www.asone.global/csp/asone/REST/api/BBsignin`, loginData, {
        headers,
      })
      .toPromise();
  
  }

  async register(registerData:any) {
    let headers = new HttpHeaders({
      "apiKey": "G37BF2948D54BB2A5CEF4D1BD3F3CA3123",
      "Content-Type":"application/json",
    });

    try {
      const registerResponse: any = await this.http
        .post(`https://www.asone.global/csp/asone/REST/api/BBregistration`, registerData, {
          headers,
        })
        .toPromise();

        this.router.navigateByUrl('/auth/login');

        if (registerResponse.success) {
          
        }else{
          throw 'Something went wrong';
        }

    } catch (error) {
      console.error('Error registering user:', error);
      throw 'Something went wrong';
    }


  }

  async forgotPasswrod(forgotData:any) {
    let headers = new HttpHeaders({
      "apiKey": "G37BF2948D54BB2A5CEF4D1BD3F3CA3123",
      "Content-Type":"application/json",
    });

    return this.http
      .post(`https://www.asone.global/csp/asone/REST/api/BBforgotPIN`, forgotData, {
        headers,
      })
      .toPromise();
      


    return this.http
      .post(`${environment.static_image_url}/api/auth/customer_forgot_password`, forgotData, {
          headers,
        })
      .toPromise();
  }

  async verifyOtp(forgotData:any) {
    let headers = new HttpHeaders({
       x_api_key: environment.XKEY_static_files,
    });

    return this.http
      .post(`${environment.static_image_url}/api/auth/verify_customer_otp`, forgotData, {
          headers,
        })
      .toPromise();
  }

  async updatePassword(updateData:any) {
    let headers = new HttpHeaders({
       x_api_key: environment.XKEY_static_files,
    });

    return this.http
      .post(`${environment.static_image_url}/api/auth/customer_update_password`, updateData, {
          headers,
        })
      .toPromise();
  }

  isAuthenticated() {
    if (
      sessionStorage.getItem('sessionToken') != '' &&
      sessionStorage.getItem('sessionToken') != undefined
    ) {
      return true;
    } else {
      return false;
    }
  }

  getSessionToken() {
    return sessionStorage.getItem('sessionToken');
  }
  getAdreToken() {
    return localStorage.getItem('AndreToken');
  }

  logout() {
    this.user = undefined;
  }

  constructor(private http: HttpClient, private router: Router) {}
}
